<h4>Universitys</h4>
<form [formGroup]="searchform">
<div class="row mb-5" *ngIf="unis!=null">
  <div class="col-6">
    <input class="form-control" formControlName="search" placeholder="Type here ..." type="text">
  </div>
  <div class="col-6">
    <button class="btn btn-neutral-warning mr-3" (click)="search(1)">Search</button>
    <button class="btn btn-neutral-success" (click)="window('ad','')">Create new</button>
  </div>
</div>
</form>
<div class="row justify-content-center" *ngIf="unis==null">
  <div class="spinner-border m-2 text-danger" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="row" *ngIf="dest!=null">
  <div class="col-xl-4 col-lg-6" *ngFor="let d of unis">
    <div class="card mb-5">
      <img alt="..." class="card-img-top" src="data:image/png;base64,{{d.image}}"/>
      <div class="card-body">
        <h5 class="card-title font-weight-bold font-size-lg">{{d.name}}</h5>
<!--        <p class="card-text">{{(d.description  | slice:0:100) + '...'}}</p>-->
        <button class="btn btn-sm btn-neutral-warning mr-3" (click)="window('up',d)"> update</button>
        <button class="btn btn-sm btn-neutral-danger " (click)="delete(d.id)"> delete</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{ty}} University</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body row">
          <div class="col-6">
            <form [formGroup]="form">
              <div class="m-2">
                <select class="form-control" placeholder="Title" type="text" formControlName="dest">
                  <option *ngFor="let d of dest" value="{{d.id}}">{{d.name}}</option>
                </select>
              </div>
              <div class="m-2">
                <input class="form-control" placeholder="Title" type="text" formControlName="name">
              </div>
<!--              <div class="m-2">-->
<!--                <textarea class="form-control" placeholder="Description" formControlName="desc" c rows="10"></textarea>-->
<!--              </div>-->

            </form>
          </div>

          <div class="col-5">
            <div class="custom-file">
              <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01">
              <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
            </div>
            <image-cropper
              class="rounded-sm"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded()"
              [alignImage]="'center'"
              [aspectRatio]="4 / 3"
              [cropperMinWidth]="340"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [onlyScaleDown]="true"
              [resizeToWidth]="340"
              [roundCropper]="false"
              [style.display]="showCropper ? null : 'none'"
              format="png"
              outputType="file"
            ></image-cropper>
            <div class="font-size-lg text-center text-danger p-5" [hidden]="showCropper">
              <h5 class="display-4 text-black mb-3 font-weight-bold">Cropped image</h5>
              To see the image cropper in action, upload an image using the left form input.
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <button *ngIf="up!=true" type="button" class="btn btn-success ml-auto" [disabled]="!form.valid"  (click)="new()">Save changes</button>
        <button *ngIf="up==true"type="button" class="btn btn-warning ml-auto" [disabled]="!form.valid"  (click)="update()">Update</button>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
